import { useEffect } from "react";

/**
 * VB-39 — THE TAB TITLE (2026-08-22).
 *
 * Every screen in `/next` shared one `<title>`, set once in `client/index.html` and never touched
 * again: `ValuBrief /next` — the app's internal codename — on `/cma`, `/result-demo`, `/branding`
 * and `/crm` alike. `LandingPage` was the only module in the client that assigned
 * `document.title`, so the landing was the only screen with a name.
 *
 * The cost is not cosmetic. An agent who runs briefs weekly keeps several open and comes back to
 * them tomorrow; tabs, history entries and bookmarks were all identical strings, so the browser's
 * own affordances for finding your way back were carrying no information at all.
 *
 * SUFFIX, NOT PREFIX. The distinguishing word goes first because a browser tab truncates from the
 * right — "2312 Cross Bend Rd — Val…" tells you which brief, "ValuBrief — 2312 Cro…" does not.
 *
 * The title is restored on unmount to whatever was there when this screen mounted, so a route
 * change never leaves a stale name behind and nothing has to know the order screens appear in.
 */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}

/** The one place the suffix is spelled, so a rename is one edit. */
export function vbTitle(name: string) {
  return `${name} — ValuBrief`;
}
